import React, { useState, useEffect } from 'react';
import AlquilerEditor from './AlquilerEditor';
import { connect } from 'react-redux';
import {
  setPending,
  deleted,
  getAllByParent,
} from '../redux/actions/alquilerActions';

import { callStatus } from '../utils/constants';
import { Button, Layout, Modal, Space, Tag } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  ExclamationCircleOutlined,
  EditFilled,
  DeleteFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import MetaTable from './base/MetaTable';
import CustomCellRender from './base/CustomCellRender';
import dayjs from 'dayjs';
import { convertDate } from '../utils/funtions';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;

const AlquilerList = ({
  location,
  dispatch,
  stateData,
  match,
  campanaId,
  parent,
  history,
}) => {
  const id = campanaId || (match && match.params ? match.params.id : null);
  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  useEffect(() => {
    dispatch(getAllByParent(id));
    dispatch(setPending());
    // eslint-disable-next-line
  }, []);

  const handleEdit = (data) => {
    dispatch(setPending());
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleView = (record) => {
    history.push(`/campanas/${id}/alquileres/${record.id}`);
  };

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <SearchOutlined onClick={() => handleView(record)} />
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 90,
      ellipsis: true,
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
      render: (text) =>
        text ? dayjs(convertDate(text)).format('DD/MM/YYYY') : '',
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Número',
      dataIndex: 'numero',
      render: (text, record) => (
        <span className="hover-bold-link" onClick={() => handleView(record)}>
          {text}
        </span>
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Superficie Ha',
      dataIndex: 'superficie',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 200,
      title: 'Modalidad de contrato',
      dataIndex: 'contrato_unico',
      render: (contrato_unico) =>
        contrato_unico ? (
          <Tag color="cyan">Contrato Único</Tag>
        ) : (
          <Tag color="purple">Multicontrato</Tag>
        ),
    },
    {
      title: 'Propietarios',
      dataIndex: 'alquiler_propietarios',
      render: (_, { alquiler_propietarios }) => (
        <>
          {alquiler_propietarios.map((tag, index) => {
            return (
              <Tag color="green" key={index}>
                {tag.propietario?.nombre}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Actividades',
      dataIndex: 'alquiler_actividades',
      render: (_, { alquiler_actividades }) => (
        <>
          {alquiler_actividades.map((tag, index) => {
            return (
              <Tag color="geekblue" key={index}>
                {tag.actividad?.establecimiento.nombre} /{' '}
                {tag.actividad?.cultivo.nombre}
              </Tag>
            );
          })}
        </>
      ),
    },
  ];

  return (
    <>
      <Layout style={{ height: '100%' }}>
        <Header></Header>
        <Content>
          <MetaTable
            dataSource={stateData.list.data}
            dataColumns={columns}
            bordered={false}
            selection={false}
            loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
          />
        </Content>
        <Footer>
          <FooterContainer>
            <SelectedContainer></SelectedContainer>
            <ActionsContainer>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                size="small"
                onClick={(e) => handleEdit({})}
              >
                Agregar Alquiler
              </Button>
            </ActionsContainer>
          </FooterContainer>
        </Footer>
      </Layout>
      {showEdit ? (
        <AlquilerEditor
          id={rowEdit.id}
          parentId={id}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { alquiler, campana } = state;
  const stateData = alquiler;
  const parent = campana;
  return {
    stateData,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(AlquilerList));
